import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[onlyNumber]',
})
export class OnlynumberDirective {
  @Input() allowDecimal: boolean;
  constructor(private _el: ElementRef) {}

  @HostListener('input', ['$event']) onInputChange(event) {
    const initalValue = this._el.nativeElement.value;
    const regex = this.allowDecimal ? /[^0-9.]*/g : /[^0-9]*/g;
    this._el.nativeElement.value = initalValue.replace(regex, '');
    if (initalValue !== this._el.nativeElement.value) {
      event.stopPropagation();
    }
  }
}
